export default __webpack_public_path__ + "static/media/inicio2-min.f0800316.jpg";